import { render } from "./portalStudent.vue?vue&type=template&id=8c313850&scoped=true"
import script from "./portalStudent.vue?vue&type=script&lang=js"
export * from "./portalStudent.vue?vue&type=script&lang=js"

import "./portalStudent.vue?vue&type=style&index=0&id=8c313850&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c313850"]])

export default __exports__